import React, { useState } from 'react';

const SummerTransformation = () => {
  // 1. Add states for handling status
  const [status, setStatus] = useState('idle');
  const [statusMsg, setStatusMsg] = useState('');

  // 2. Add the submission logic
  const handleInlineSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');

    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());

    try {
      const response = await fetch('/sendmail.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });

      const result = await response.json();

      if (result.status === 'success') {
        setStatus('success');
        setStatusMsg("Registration Successful! We'll call you shortly.");
        e.target.reset(); 
      } else {
        throw new Error("Server error");
      }
    } catch (error) {
      setStatus('error');
      setStatusMsg("Something went wrong. Please call 9700213084.");
    }
  };

  // 3. Add the phone number validator
  const handlePhoneInput = (e) => {
    e.target.value = e.target.value.replace(/[^0-9]/g, '');
  };

  return (
    <section className="transformation-section" id="about">
      <div className="container transformation-grid">
        
        {/* Left Side: The Story (Unchanged) */}
        <div className="transformation-content">
          <span className="section-subtitle">Why 2,000+ Parents Choose Us</span>
          <h2 className="transformation-title">The 40-Day <span className="text-blue">Headstart</span></h2>
          <p className="transformation-text">
            Since 2014, we have mastered the art of "Pre-School Preparation." 
            By completing the core syllabus during the summer, we remove the pressure 
            of the academic year, allowing students to lead their classrooms with confidence.
          </p>
          <div className="transformation-benefits">
            <div className="benefit-item">
              <strong>Zero Exam Fear:</strong> Syllabus mastery before school begins.
            </div>
            <div className="benefit-item">
              <strong>Conceptual Clarity:</strong> Deep-dive into MPC subjects.
            </div>
            <div className="benefit-item">
              <strong>Holistic Growth:</strong> Academic excellence meets 21st-century skills.
            </div>
          </div>
        </div>

        {/* Right Side: Inline Form (Updated Logic) */}
        <div className="inline-form-wrapper">
          <div className="inline-form-card">
            <h3>Secure Your Spot</h3>
            <p>Registration for April 24th Batch is now open.</p>

            {/* Display Status Messages */}
            {status === 'success' && <div className="status-msg success">{statusMsg}</div>}
            {status === 'error' && <div className="status-msg error">{statusMsg}</div>}

            {status !== 'success' && (
              <form className="summer-inline-form" onSubmit={handleInlineSubmit}>
                {/* Updated name attributes for PHP sync */}
                <input 
                  type="text" 
                  name="student_name" 
                  placeholder="Student Name" 
                  required 
                  disabled={status === 'loading'}
                />
                <input 
                  type="tel" 
                  name="parent_phone" 
                  placeholder="Parent's Mobile Number" 
                  required 
                  maxLength="10"
                  onInput={handlePhoneInput}
                  disabled={status === 'loading'}
                />
                <select name="selected_program" required disabled={status === 'loading'}>
                  <option value="">Select Summer Track</option>
                  <option value="Advanced Foundation">Advanced Foundation</option>
                  <option value="Basic Foundation">Basic Foundation</option>
                  <option value="Intermediate Bridge">Intermediate IIT-Foundation</option>
                  <option value="10th Class Bridge">10th Class Bridge Course</option>
                  <option value="Skill Oriented">Skill Oriented Courses</option>
                </select>
                
                <input type="hidden" name="source" value="mid_page_form" />
                
                <button type="submit" className="btn-submit-inline" disabled={status === 'loading'}>
                  {status === 'loading' ? 'Processing...' : 'Register for Summer Camp'}
                </button>
              </form>
            )}
          </div>
        </div>

      </div>
    </section>
  );
};

export default SummerTransformation;